import { render, staticRenderFns } from "./AttributeIcon.vue?vue&type=template&id=36a792d8&scoped=true"
import script from "./AttributeIcon.vue?vue&type=script&lang=ts"
export * from "./AttributeIcon.vue?vue&type=script&lang=ts"
import style0 from "./AttributeIcon.vue?vue&type=style&index=0&id=36a792d8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36a792d8",
  null
  
)

export default component.exports